import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class ApprovalService {
  api_url = environment.SERVER_URL;
  // api_url: string = "http://192.168.0.195:4284/api/";

  constructor(private http: HttpClient) { }
  getApproval(req_res_id, user_id, status) {
    return this.http.get(this.api_url + 'Approval/Master', { params: { req_res_guid: req_res_id, user_guid: user_id, status: status } });
  }
  getRequirementApproval(req_res_id, user_id, status) {
    return this.http.get(this.api_url + 'ReqApproval/Master', { params: { req_guid: req_res_id, user_guid: user_id, status: status } });
  }
}
